"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopBanner = exports.Root = exports.Inner = exports.Description = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        overflow: 'hidden'
    };
});
const TopBanner = exports.TopBanner = (0, _mui.styled)(_presentationComponents.TopBanner)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 0, 3, 0),
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(0, 0, 6, 0)
        }
    };
});
const Description = exports.Description = (0, _mui.styled)(_editorialComponents.Description)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(6),
        maxWidth: 630,
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(10)
        }
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        paddingLeft: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingLeft: 0
        }
    };
});
